import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/models/user/user.model';
import { Component, Inject } from '@angular/core';

export interface DeaUsersFilterDialogData {
  users: User[];
  selectAll: boolean;
}

@Component({
  selector: 'app-dea-users-filter-dialog',
  templateUrl: './dea-users-filter-dialog.component.html',
  styleUrl: './dea-users-filter-dialog.component.scss',
})
export class DeaUsersFilterDialogComponent {
  users: User[] = [];
  selectedUsers: User[] = [];

  constructor(
    private _dialogRef: MatDialogRef<DeaUsersFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: DeaUsersFilterDialogData
  ) {
    this.users = data.users.filter((u) => u.id !== undefined && u.id !== null);
    if (data.selectAll == true) this.selectedUsers = [...this.users];
  }

  get selectedUsersLength(): number {
    return this.selectedUsers.length;
  }

  get selectedUsersId(): string[] {
    return this.selectedUsers.map((user) => user.id!);
  }

  get allUsersId(): string[] {
    return this.users.map((user) => user.id!);
  }

  isChecked(id: string | undefined): boolean {
    if (id === undefined) return false;
    return this.selectedUsersId.includes(id);
  }

  onChangeCheckbox(id: string | undefined) {
    if (!id) return;
    const user = this.users.find((u) => u.id === id);
    if (!user) return;
    const index = this.selectedUsers.findIndex((u) => u.id === id);
    if (index === -1) {
      this.selectedUsers.push(user); // AGGIUNGI
    } else {
      this.selectedUsers.splice(index, 1); // RIMUOVI
    }
  }

  onConfirm(): void {
    this._dialogRef.close(this.selectedUsers);
  }

  onDismiss(): void {
    this._dialogRef.close(false);
  }
}
